
import Vue from "vue";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import { FontFace } from "@/types/custom-fonts";
import { CSS_WEIGHTS } from "@/lib/fonts/constants";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: { Icon }
})
export default class UpdateFontFace extends Vue {
  @Ref() readonly form!: HTMLFormElement;
  @Prop()
  value!: FontFace;

  /* Form Validation */
  @Prop({
    default: []
  })
  existingFontFaces!: FontFace[];

  isFontFaceUnique = true;

  validateWeight(weight: number) {
    if (!weight) {
      return "A weight is required";
    }

    return (
      !this.existingFontFaces
        .find(
          fontFace =>
            fontFace.weight === weight && fontFace.style === this.value.style
        )
        ?.files.find(file => this.valueFormats.includes(file.format)) ||
      "This font weight already exists with this style, and format"
    );
  }

  validateStyle(style: "normal" | "italic") {
    return (
      !this.existingFontFaces
        .find(
          fontFace =>
            fontFace.weight === this.value.weight && fontFace.style === style
        )
        ?.files.find(file => this.valueFormats.includes(file.format)) ||
      "This font style already exists with this weight, and format"
    );
  }

  get valueFormats() {
    return this.value.files.map(file => file.format);
  }

  @Watch("value")
  revalidateOnValueChange() {
    this.form.validate();
  }
  /* ------------ */

  updateWeight(newWeight: number) {
    const newValue = {
      ...this.value,
      weight: newWeight
    };
    this.$emit("input", newValue);
  }

  updateStyle(newStyle: "normal" | "italic") {
    const newValue = {
      ...this.value,
      style: newStyle
    };
    this.$emit("input", newValue);
  }

  deleteFontFace() {
    this.$emit("delete");
  }

  get weights() {
    return CSS_WEIGHTS;
  }

  get currentWeight() {
    return CSS_WEIGHTS.find(w => w.value === this.value.weight);
  }
}
